import { marked } from 'marked'

export function wordCounter(params) {
  if (params[0]) {
    return params[0].split(' ').filter((e) => e !== '').length
  } else {
    return 0
  }
}

export function characterCounter(params) {
  if (params[0]) {
    return params[0].length
  } else {
    return 0
  }
}

export function addCssClassForUnderscoredElement(survey, options){
  const classes = options.cssClasses
  const elementName = options.question.propertyHash.name
  if (elementName.includes('_')) {
    const extraClass = elementName.split('_')[0]
    classes.root += extraClass
  }
}

export function parseMarkdown(survey, options) {
  let str = marked.parse(options.text).trim()
  str = str.substring(3)
  str = str.substring(0, str.length - 4)
  options.html = str
}
